export default {
  courses: [],
  menuCourses: [],
  course: {},
  lastLessons: [],
  lessons: [],
  pagination: {},
  menuPagination: {},
  recommendedOptions: [],
  recommendedHome: [],
  trails: [],
  mentorship: {}
};
